import React from 'react'
import classes from './CargoList.module.sass'
import { CargoItemInterface } from '../../../../common/types/interfaces'
import { CargoItem } from './components/cargoItem/CargoItem'
import { SkeletonLoader } from '../../../../common/components/skeletonLoader/SkeletonLoader'

type Props = {
  list: CargoItemInterface[]
  toggleSelected: (item: CargoItemInterface) => void
  loading: boolean
}

export const CargoList = ({ list, toggleSelected, loading }: Props) => {
  if (loading)
    return (
      <div className={classes.Container}>
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
      </div>
    )
  return (
    <div className={classes.Container}>
      {list.map((el) => (
        <CargoItem item={el} key={el.id} toggleSelected={toggleSelected} />
      ))}
    </div>
  )
}
